// All Pokemon built from pokemonData, formatted for quiz use.
// Replaces the small COMPETITIVE_POKEMON pool so quizzes use the full Pokedex.
import { POKEMON_DATA } from './pokemonData';
import { MOVES } from './moves';

function formatPokemonName(key) {
  return key.split('-').map(w => w.charAt(0).toUpperCase() + w.slice(1)).join(' ');
}

// Group moves by type so each Pokemon gets type-appropriate moves for DamageCalcQuiz
const MOVES_BY_TYPE = {};
Object.entries(MOVES).forEach(([name, move]) => {
  if (!MOVES_BY_TYPE[move.type]) MOVES_BY_TYPE[move.type] = [];
  MOVES_BY_TYPE[move.type].push(name);
});

// PokeAPI sprites exist for IDs 1–1025 and 10001–10277.
// IDs > 10277 are custom entries not in PokeAPI's sprite repo — fall back to
// the base Pokemon's ID by stripping the form suffix and looking it up.
const MAX_POKEAPI_FORM_ID = 10277;

function getSpriteId(key, id) {
  if (id <= MAX_POKEAPI_FORM_ID) return id;
  const baseKey = key
    .replace(/-mega-[xyz]$/, '')
    .replace(/-mega$/, '');
  if (POKEMON_DATA[baseKey]?.id) return POKEMON_DATA[baseKey].id;
  const fuzzy = Object.keys(POKEMON_DATA).find(
    k => k.startsWith(baseKey + '-') && POKEMON_DATA[k].id <= MAX_POKEAPI_FORM_ID
  );
  return fuzzy ? POKEMON_DATA[fuzzy].id : id;
}

export const ALL_POKEMON = Object.entries(POKEMON_DATA).map(([key, data]) => {
  const spriteId = getSpriteId(key, data.id);
  return {
    key,
    name: formatPokemonName(key),
    id: data.id,
    spriteId,
    types: data.types,
    baseSpeed: data.baseStats.spe,
    commonItems: [],
    commonMoves: data.types.flatMap(t => MOVES_BY_TYPE[t] || []),
    baseStats: data.baseStats,
  };
});
